export default __webpack_public_path__ + "static/media/javascript.afcba61e.png";